import {CtModelRouteData} from "@ctsolution/ct-framework";

export const WorkOrderRowItemRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("workorderrowitem");
